import { Stack, useTheme } from "@mui/material";

interface VehicleImageProps {
  src: string;
  alt: string;
  statusTag?: string;
}

const VehicleImage = ({ src, alt, statusTag }: VehicleImageProps) => {
  const theme = useTheme();
  return (
    <Stack
      sx={{
        position: "relative",
        pt: 2,
        width: "100%",
        height: 200,
        aspectRatio: "1.5/1",
        alignSelf: "center",
        overflow: "hidden",
      }}
    >
      {statusTag && (
        <Stack
          sx={{
            position: "absolute",
            inset: "16px 0 0",
            zIndex: 1,
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(0, 0, 0, 0.45)",
            borderTopLeftRadius: 10,
            borderTopRightRadius: 10,
            pointerEvents: "none",
          }}
        >
          <Stack
            component="span"
            sx={{
              width: "125%",
              py: 1,
              alignItems: "center",
              justifyContent: "center",
              transform: "rotate(-28deg)",
              backgroundColor: theme.palette.primary.main,
              opacity: 0.5,
              color: theme.palette.common.white,
              fontSize: 22,
              fontWeight: 800,
              lineHeight: 1,
              fontFamily: "Work Sans",
              letterSpacing: 0,
              textTransform: "uppercase",
              boxShadow: "0 8px 18px rgba(0, 0, 0, 0.22)",
            }}
          >
            {statusTag}
          </Stack>
        </Stack>
      )}
      <img
        src={src}
        alt={alt}
        loading="lazy"
        style={{
          width: "100%",
          borderTopLeftRadius: 10,
          borderTopRightRadius: 10,
          aspectRatio: "1.5/1",
          objectFit: "cover",
        }}
      />
    </Stack>
  );
};

export { VehicleImage };
